"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _util = require("./util.js");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _find2 = _interopRequireDefault(require("lodash/find"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var FrequencyTable = function FrequencyTable(props) {
  var renderFrequencyTable = function renderFrequencyTable(chart) {
    var valueHeader = props.valueHeader,
      mapHeader = props.mapHeader,
      labels = props.labels,
      map = props.map,
      showPercentage = props.showPercentage;
    var uniqueLabels = _toConsumableArray(new Set(labels));
    var usesMap = labels.length === uniqueLabels.length && map.length > 0;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].freqTableWrap
    }, /*#__PURE__*/_react["default"].createElement("table", {
      className: _style["default"].freqTable
    }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", {
      className: _style["default"].barBelow
    }, /*#__PURE__*/_react["default"].createElement("th", {
      className: _style["default"].tableLabel
    }, valueHeader), usesMap && /*#__PURE__*/_react["default"].createElement("th", {
      className: _style["default"].tableLabel
    }, mapHeader), /*#__PURE__*/_react["default"].createElement("th", null, "Frequency"), showPercentage && /*#__PURE__*/_react["default"].createElement("th", null, "Percentage"))), /*#__PURE__*/_react["default"].createElement("tbody", null, renderFrequencyTableRows(chart))));
  };
  var getFrequencyTableData = function getFrequencyTableData() {
    var data = props.data,
      labelPath = props.labelPath,
      valuePath = props.valuePath,
      ignoreLabels = props.ignoreLabels,
      ignoreValues = props.ignoreValues,
      labels = props.labels;
    var uniqueLabels = _toConsumableArray(new Set(labels));
    var populated = uniqueLabels.map(function (item) {
      var row = [];
      row.parentLink = 1;
      row[labelPath] = item;
      row[valuePath] = (0, _get2["default"])((0, _find2["default"])(data, [labelPath, item]), valuePath, 0);
      return row;
    });
    var filtered = populated.filter(function (row) {
      return !ignoreLabels.includes(row[labelPath]) && !ignoreValues.includes(row[valuePath]);
    });
    var total = filtered.reduce(function (cume, row) {
      return cume + row[valuePath];
    }, 0);
    var sorted = sortRows(filtered);
    return sorted.map(function (row) {
      return {
        label: row[labelPath],
        value: row[valuePath],
        percentage: total === 0 ? 0 : parseFloat(row[valuePath]) * 100.0 / parseFloat(total)
      };
    }).concat([{
      label: 'TOTAL ',
      value: total,
      percentage: total === 0 ? 'NA' : 100.0
    }]);
  };
  var sortRows = function sortRows(data) {
    var newData = data;
    var labels = props.labels;
    var order = {};
    var index = 1;
    var _iterator = _createForOfIteratorHelper(labels),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var label = _step.value;
        order[label] = index;
        index++;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (props.orderByLabel) {
      if (props.orderByNumeric) {
        newData.sort((0, _util.sortByValueNumeric)(props.labelPath));
      } else {
        newData.sort((0, _util.sortByValue)(props.labelPath));
      }
    } else if (props.orderByValue) {
      if (props.orderByNumeric) {
        newData.sort((0, _util.sortByValueNumeric)(props.valuePath));
      } else {
        newData.sort((0, _util.sortByValue)(props.valuePath));
      }
    } else {
      // preserve order of labels
      newData.sort(function (a, b) {
        return order[a[props.labelPath]] - order[b[props.labelPath]];
      });
    }
    if (props.reverseData) {
      newData.reverse();
    }
    return newData;
  };
  var renderFrequencyTableRows = function renderFrequencyTableRows() {
    var data = getFrequencyTableData();
    var map = props.map,
      showPercentage = props.showPercentage,
      labels = props.labels;
    var uniqueLabels = _toConsumableArray(new Set(labels));
    var usesMap = labels.length === uniqueLabels.length && map.length > 0;
    return data.map(function (row, index) {
      var mapped = null;
      if (usesMap) {
        if (row.label in map) {
          mapped = /*#__PURE__*/_react["default"].createElement("td", {
            className: _style["default"].tableLabel
          }, map[row.label]);
        } else {
          mapped = /*#__PURE__*/_react["default"].createElement("td", {
            className: _style["default"].tableLabel
          }, "\xA0");
        }
      }
      return /*#__PURE__*/_react["default"].createElement("tr", {
        key: index,
        className: row.label === 'TOTAL ' ? _style["default"].barAbove : ''
      }, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].tableLabel
      }, row.label), usesMap && mapped, /*#__PURE__*/_react["default"].createElement("td", null, row.value), showPercentage && /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].tableValue
      }, row.percentage === 'NA' ? 'NA' : row.percentage.toFixed(1) + '%'));
    });
  };
  return renderFrequencyTable();
};
FrequencyTable.propTypes = {
  data: _propTypes["default"].array.isRequired,
  map: _propTypes["default"].array,
  labels: _propTypes["default"].array,
  labelPath: _propTypes["default"].string,
  valuePath: _propTypes["default"].string,
  ignoreLabels: _propTypes["default"].array,
  ignoreValues: _propTypes["default"].array,
  valueHeader: _propTypes["default"].string,
  mapHeader: _propTypes["default"].string,
  showPercentage: _propTypes["default"].bool
};
FrequencyTable.defaultProps = {
  map: [],
  labels: [],
  showPercentage: true,
  labelPath: 'value',
  valuePath: 'valueCount',
  ignoreLabels: [],
  ignoreValues: [],
  valueHeader: 'Value',
  mapHeader: 'Coding'
};
var _default = exports["default"] = FrequencyTable;